import { useState } from 'react';
import './App.css';

type Language = 'sk' | 'en';

interface Translations {
  warning: string;
  operatorChanged: string;
  newOperator: string;
  redirectInfo: string;
  redirectNote: string;
  pathNote: string;
  agreeTerms: string;
  termsLink: string;
  pricingLink: string;
  understand: string;
  redirecting: string;
  mustAgree: string;
}

const translations: Record<Language, Translations> = {
  sk: {
    warning: '✨ Novinka',
    operatorChanged: 'Naša služba prechádza na vylepšeného prevádzkovateľa, aby sme vám mohli prinášať ešte lepšie služby a pohodlnejšie používanie.',
    newOperator: 'Nový prevádzkovateľ',
    redirectInfo: 'Po potvrdení budete bezpečne presmerovaní na:',
    redirectNote: 'show.cdhxportal.com',
    pathNote: '',
    agreeTerms: 'Súhlasím s novými',
    termsLink: 'všeobecnými obchodnými podmienkami',
    pricingLink: 'cenníkom',
    understand: 'Pokračovať',
    redirecting: 'Presmerovávam...',
    mustAgree: 'Najprv musíte súhlasiť s VOP a cenníkom',
  },
  en: {
    warning: '✨ New',
    operatorChanged: 'Our service is transitioning to an improved operator to bring you even better services and more convenient usage.',
    newOperator: 'New operator',
    redirectInfo: 'After confirmation you will be safely redirected to:',
    redirectNote: 'show.cdhxportal.com',
    pathNote: '',
    agreeTerms: 'I agree to the new',
    termsLink: 'Terms and Conditions',
    pricingLink: 'Pricing',
    understand: 'Continue',
    redirecting: 'Redirecting...',
    mustAgree: 'You must agree to the Terms and Pricing first',
  },
};

function App() {
  const [understood, setUnderstood] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [language, setLanguage] = useState<Language>('sk');

  const t = translations[language];

  // Determine which pricing PDF to show based on URL
  const pricingPdf = window.location.pathname.includes('/savings') ? '/kb.pdf' : '/hodlx.pdf';

  const handleUnderstand = () => {
    setUnderstood(true);
    // Get the current path and query parameters
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const currentHash = window.location.hash;

    // Redirect to new domain with the same path and parameters
    const newUrl = `https://show.cdhxportal.com${currentPath}${currentSearch}${currentHash}`;
    window.location.href = newUrl;
  };

  return (
    <div className="App">
      <div className="language-switcher">
        <button
          className={`lang-btn ${language === 'sk' ? 'active' : ''}`}
          onClick={() => setLanguage('sk')}
        >
          SK
        </button>
        <span className="lang-separator">|</span>
        <button
          className={`lang-btn ${language === 'en' ? 'active' : ''}`}
          onClick={() => setLanguage('en')}
        >
          EN
        </button>
      </div>

      <div className="redirect-container">
        <div className="redirect-card">
          <h1>{t.warning}</h1>
          <p className="main-text">
            {t.operatorChanged}
          </p>
          <p className="operator-info">
            {t.newOperator}: <strong>cdhxportal.com</strong>
          </p>
          <p className="redirect-info">
            {t.redirectInfo}
            <br />
            <strong>{t.redirectNote}</strong>
          </p>

          <div className="terms-container" style={{margin: '20px 0', textAlign: 'left'}}>
            <label style={{display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer'}}>
              <input
                type="checkbox"
                checked={agreedToTerms}
                onChange={(e) => setAgreedToTerms(e.target.checked)}
                style={{width: '18px', height: '18px', cursor: 'pointer', marginTop: '2px'}}
              />
              <span style={{fontSize: '14px'}}>
                {t.agreeTerms}{' '}
                <a
                  href="/llc.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#007bff',
                    textDecoration: 'underline',
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {t.termsLink}
                </a>
                {language === 'sk' ? ' a s ' : ' and '}
                <a
                  href={pricingPdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#007bff',
                    textDecoration: 'underline',
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {t.pricingLink}
                </a>
              </span>
            </label>
          </div>
          <button
            className="understand-button"
            onClick={handleUnderstand}
            disabled={understood || !agreedToTerms}
            title={!agreedToTerms ? t.mustAgree : ''}
            style={{
              opacity: !agreedToTerms ? 0.5 : 1,
              cursor: !agreedToTerms ? 'not-allowed' : 'pointer'
            }}
          >
            {understood ? t.redirecting : t.understand}
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;